import type { ProductConfig } from '#types/config/components/product'

export default {
  brandClasses: {
    badge: 'items-center gap-1 text-xs i-flex'
  },
  iconSize: 'md'
} satisfies ProductConfig['badge']
